import {createSelector, type Selector} from "@reduxjs/toolkit";

import {fetchSelectors} from "@atg-shared/fetch-redux";

import type {GlobalState as State} from "./teamTypes";
import type {LoadingStatus} from "@atg-shared/fetch-types";

export const teamState = (state: State) => state.teams;

const getTeam = (state: State) => teamState(state).team;

export const getTeamId = (state: State): string | null => getTeam(state).teamId;

const imageUploadState = (state: State) => teamState(state).imageUploadFlow;
export const isImageUploadLoading = (state: State) => imageUploadState(state).loading;
export const getImageUploadError = (state: State) => imageUploadState(state).error;

const revokeAppliciationState = (state: State) => teamState(state).revokeApplication;

export const getRevokeApplicationStatus: Selector<State, LoadingStatus> = createSelector(
    revokeAppliciationState,
    fetchSelectors.getLoadingStatus,
);

export const createTeamState = (state: State) => teamState(state).createTeamFlow;
